import PropTypes from 'prop-types';
import React from 'react';
import { daysSinceDateLocal } from 'common/util/dateTime';
import { getTimezoneOffset } from '../../../../common/selectors';
import styles from './DaysInLifecycle.scss';
import { LIFECYCLE_UNASSIGNED } from 'common/util/studyHelpers';
import { connect } from 'react-redux';

function DaysInLifecycle(props) {
    const currentStage = props.currentStage;
    const days = props.days;
   

    let stageName = LIFECYCLE_UNASSIGNED;

    if (currentStage) {
        stageName = currentStage.name && currentStage.name.toUpperCase();
    }

    return (
        <div className={styles.daysInLifecycle} data-cy="DaysInLifecycle-div">
            <div>
                <h2># of Days in Lifecycle Stage</h2>
                <h3 data-cy="DaysInLifecycle-stageName">{stageName}</h3>
            </div>
            <p data-cy="DaysInLifecycle-days">{days}</p>
        </div>
    );
}

DaysInLifecycle.propTypes = {
    currentStage: PropTypes.object,
    stageProgressions: PropTypes.array,
};

export const getMostRecentStageProgression = (progressions, stageId) => progressions
    .sort((p1, p2) => p1.createdAt - p2.createdAt)
    .find(stage => stage.currentStageId == stageId);



// We normally do both in one step, like this:
// connect(mapStateToProps, mapDispatchToProps)(Component)

export default connect((state, props) => {
    const currentStage = props.currentStage;
    const stageProgressions = props.stageProgressions || [];
    const currentStageId = currentStage && currentStage.id;

    const currentStageProgression = getMostRecentStageProgression(stageProgressions, currentStageId);

    let days = null;
    const timezoneOffset = getTimezoneOffset(state);
    if (currentStageProgression) {
        days = daysSinceDateLocal(currentStageProgression.createdAt, timezoneOffset);
    }

    return {
        currentStage,
        days
    };
}, {})(DaysInLifecycle);